<div class="text-center">
    <ul *ngIf="data">
        <li *ngFor="let message of data;let i=index">{{message}}</li>
    </ul>
</div>
